<template>
    <div
        v-if="show"
        :class="{ active: show }"
        class="uk-modal"
    >
        <div
            role="dialog"
            :aria-labelledby="`modal-header-${id}`"
            aria-modal="true"
            class="uk-modal-dialog"
        >
            <dismiss-link
                v-if="dismissable"
                @click="maybe_dismiss"
                class="uk-modal-close uk-close"
            />
            <div
                tabindex="0"
                @focus="loop_to_last"
            ></div>
            <div
                v-if="has_slot('title')||has_slot('subtitle')"
                class="uk-modal-header"
            >
                <h2 v-if="has_slot('title')">
                    <slot name="title"></slot>
                </h2>
                <h6 v-if="has_slot('subtitle')" class="uk-margin-top-remove">
                    <slot name="subtitle"></slot>
                </h6>
            </div>
            <div class="uk-modal-body">
                <slot></slot>
            </div>
            <div
                v-if="has_slot('footer')"
                class="uk-modal-footer uk-text-center"
            >
                <slot name="footer"></slot>
            </div>
            <div
                tabindex="0"
                @focus="loop_to_first"
            ></div>
        </div>
    </div>
</template>

<script>
import is_nibnut_component from "../../mixins/IsNibnutComponent"

import DismissLink from "./DismissLink"

export default {
    name: "ModalDialog",
    mixins: [is_nibnut_component],
    components: {
        DismissLink
    },
    created () {
        this.toggle_event_listener()
    },
    beforeDestroy () {
        if(this.show) this.dismiss()
    },
    watch: {
        show: "toggle_event_listener"
    },
    methods: {
        toggle_event_listener () {
            const escaped = event => {
                if((event.keyCode === 27) && this.show && this.dismissable) this.dismiss()
            }
            if(this.show) {
                document.addEventListener("keydown", escaped)
            } else {
                document.removeEventListener("keydown", escaped)
            }
        },
        loop_to_last () {
            const target = document.getElementById("last_focusable")
            if(target) this.$nextTick(() => target.focus())
        },
        loop_to_first () {
            const target = document.getElementById("")
            if(target) this.$nextTick(() => target.focus())
        },
        dismiss () {
            this.$emit("update:show", false)
        },
        maybe_dismiss () {
            if(this.dismissable) this.dismiss()
        }
    },
    props: {
        id: {
            type: String,
            validator: prop => !!prop,
            required: true
        },
        show: {
            type: Boolean,
            default: false
        },
        dismissable: {
            type: Boolean,
            default: true
        }
    }
}
</script>
